module.exports = __webpack_public_path__ + "static/media/image1.4fa7a6aa.png";